import { EventEmitter } from "events"
import dispatcher from "../dispatcher"

class UserI9Store extends EventEmitter {
    constructor() {
        super()
        this.setMaxListeners(0)
        this.i9 = null
        this.i9Pdf = null
    }

    getI9() {
        return this.i9
    }

    getI9Pdf() {
        return this.i9Pdf
    }

    receiveUserI9(i9) {
        this.i9 = i9
        this.emit("change")
    }

    receiveUserI9Pdf(i9Pdf) {
        this.i9Pdf = "data:application/pdf;base64," + i9Pdf
        this.emit("change")
    }

    handleActions(action) {
        switch (action.type) {
            case "RECEIVE_USER_I9": {
                this.receiveUserI9(action.object)
                break
            }
            case "RECEIVE_USER_I9_PDF": {
                this.receiveUserI9Pdf(action.object)
                break
            }
        }
    }
}

const userI9Store = new UserI9Store()
dispatcher.register(userI9Store.handleActions.bind(userI9Store))
export default userI9Store
